








































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';

export default {
    name: 'TheDeliveryFields',
    components: {
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            delivery: {},
        };
    },
    methods: {
        onSubmit() {
            this.$emit('addDelivery', {
                price_from: this.delivery.price_from,
                price_to: this.delivery.price_to,
                gift: this.delivery.gift,
                delivery_price: this.delivery.delivery_price,
                details: this.delivery.details,
            });
        },
    },
    created() {
        this.delivery = {
            price_from: '',
            price_to: '',
            gift: '',
            delivery_price: '',
            details: '',
        };
    },
};
